import { reduce } from 'utils'

const glsl = (strings, ...values) => (
  reduce((out, value, index) => (
    `${ out }${ value }${ strings[index + 1] }`
  ), strings[0], values)
)

export default glsl
